import React, { useState } from 'react';
import CreateChannelModal from './CreateChannelModal';

const ChannelList = ({ channels, selectedChannelId, onSelect, onCreate }) => {
  const [showCreateModal, setShowCreateModal] = useState(false);

  return (
    <div className="gh-box gh-chat-sidebar">
      <div className="gh-box-header d-flex align-items-center justify-content-between">
        <span>
          <i className="bi bi-list-ul me-2" aria-hidden="true"></i>
          Channels
        </span>
        <button
          type="button"
          className="gh-channel-add-btn"
          onClick={() => setShowCreateModal(true)}
          aria-label="Create channel"
        >
          <i className="bi bi-plus-lg" aria-hidden="true"></i>
        </button>
      </div>

      {channels.length === 0 ? (
        <div className="gh-box-body text-center text-muted-gh small">No channels yet</div>
      ) : (
        <ul className="gh-channel-list">
          {channels.map((channel) => (
            <li key={channel.id}>
              <button
                type="button"
                className={`gh-channel-list-item${channel.id === selectedChannelId ? ' active' : ''}`}
                onClick={() => onSelect(channel.id)}
              >
                # {channel.name}
              </button>
            </li>
          ))}
        </ul>
      )}

      {showCreateModal && (
        <CreateChannelModal
          onClose={() => setShowCreateModal(false)}
          onCreate={onCreate}
          onCreated={(channel) => onSelect(channel.id)}
        />
      )}
    </div>
  );
};

export default ChannelList;
